import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { JdcManagerService } from '../jdc-manager.service';
import { GtwSnackbarService } from '../../../../shared/_services/gtw-snackbar.service';

@Component({
    selector: 'gtw-jdc-assign-templates-modal',
    templateUrl: './jdc-assign-templates-modal.component.html',
    styleUrls: ['./jdc-assign-templates-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class JdcAssignTemplatesModalComponent implements OnInit, OnDestroy {
  @Input() activityKey: any;
  @Input() jcdKey: any;
  @Input() clientKey: any;
  @Input() activityRoles: any[] = [];

  @Output() saved = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  allTemplates: any[] = [];
  selectedTemplate: any = null;
  selectedTemplateRole: any = null;
  rolesTemplateMapping: any[] = [];
  templateCrudLoading = false;

  private destroy$ = new Subject<void>();

  constructor(
    private jdcManagerService: JdcManagerService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.rolesTemplateMapping = [];
    this.selectedTemplate = null;
    this.selectedTemplateRole = null;
    this.templateCrudLoading = false;

    this.jdcManagerService.getAllTemplates(this.clientKey)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.allTemplates = res?.jsonObject ?? res?.data?.jsonObject ?? [];
          if (this.allTemplates.length > 0) this.selectedTemplate = this.allTemplates[0];
          if (this.activityRoles.length > 0) this.selectedTemplateRole = this.activityRoles[0];
          this.cdr.detectChanges();
        },
        error: () => {
          this.gtwSnackbarService.openSnackBar('Problem loading templates.', 'gtw-snackbar--red');
          this.cdr.detectChanges();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.closed.emit();
  }

  addTemplateMapping(): void {
    if (!this.selectedTemplate || !this.selectedTemplateRole) return;
    this.rolesTemplateMapping.push({
      template: { ...this.selectedTemplate },
      role: { ...this.selectedTemplateRole }
    });
    this.cdr.detectChanges();
  }

  deleteTemplateMapping(index: number): void {
    this.rolesTemplateMapping.splice(index, 1);
    this.cdr.detectChanges();
  }

  clearTemplateMapping(): void {
    this.rolesTemplateMapping = [];
    this.cdr.detectChanges();
  }

  saveRolesTemplateMapping(): void {
    if (!this.rolesTemplateMapping.length) return;
    this.templateCrudLoading = true;
    const templateRoleMap = this.rolesTemplateMapping.map((m: any) => ({
      template_key: m.template?.TEMPLATE_KEY,
      jcd_ta_role_key: m.role?.jcd_ta_role_key
    }));
    this.jdcManagerService.saveTemplateMapping(
      this.activityKey, this.jcdKey, templateRoleMap
    ).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.templateCrudLoading = false;
        if (res?.callSuccess === '1' || res?.data?.callSuccess === '1') {
          this.gtwSnackbarService.openSnackBar('Activity template mapping done successfully.', 'gtw-snackbar--green');
          this.saved.emit();
        } else {
          this.gtwSnackbarService.openSnackBar('Problem saving mapping.', 'gtw-snackbar--red');
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.templateCrudLoading = false;
        this.gtwSnackbarService.openSnackBar('Problem saving mapping.', 'gtw-snackbar--red');
        this.cdr.detectChanges();
      }
    });
  }
}
